<template>
    <div class="content"> 
        <h1>{{$t('zc')}}</h1>
        <!-- <van-form  label-width="5em">
            
            <div style="display: flex;">
                
                <div style="height:24px;display: flex; border: 1px solid #ccc;">
                    <van-icon name="plus" color="#ccc" />
                    <input style="width:30px;height:22px;border:0px;" type="text" v-model="address">
                </div>

                <van-field
                    v-model="username"
                    :name="$t('sjhm')"
                  
                    :placeholder="$t('sjhm')"
                    :rules="[{ required: true, message: $t('qtxsjhm') }]"
                />
            </div>
            <van-field
                v-model="password"
                type="password"
                :name="$t('pwas')"
                :label="$t('pwas')"
                :placeholder="$t('pwas')"
                :rules="[{ required: true, message: $t('qtxqwas') }]"
            />
            <div style="display:flex">
             
                    <van-field
                    v-model="code"
                    type="password"
                    :name="$t('yzm')"
                    :label="$t('yzm')"
                    style="flex: 3;"
                    :rules="[{ required: true, message: $t('qtxyzm') }]"
                />
              
                <div style="flex: 2;line-height: 40px;"><van-button type="info" size="small" @click="sentout" :disabled ="disabled" class="buts">{{times}}</van-button></div>
            </div>
            <div style="margin: 16px;">
                <van-button round block type="info" @click="onSubmit" native-type="submit">{{$t('zc')}}</van-button>
            </div>
        </van-form> -->
        <van-form>
           <div class="phone ">
                <select @click="selectHand">
                    <option :value ="this.$route.query.value?this.$route.query.value:this.address">{{this.$route.query.value?this.$route.query.value:this.address}}</option>
                    <!-- <option value ="saab">+1029</option>
                    <option value="opel">1029</option>
                    <option value="audi">1029</option> -->
                </select>
                <van-field
                    label-width="4em"
                    v-model="username"
                    :name="$t('sjhm')"
                  
                    :placeholder="$t('sjhm')"
                    :rules="[{ required: true, message: $t('qtxsjhm') }]"
                />
           </div>
           <div class="">
               <van-field
                    label-width="5em"
                    v-model="password"
                    type="password"
                    :name="$t('pwas')"
                    :label="$t('pwas')"
                    :placeholder="$t('pwas')"
                    :rules="[{ required: true, message: 'sss' }]"
                    
                />
           </div>
           <div class="">
               <van-field
                    label-width="5em"
                    v-model="password"
                    type="password"
                    :name="$t('pwas')"
                    :label="$t('qrmm')"
                    :placeholder="$t('qrmm')"
                    :rules="[{ required: true, message: 'sss' }]"
                    
                />
           </div>
           
            <div class="">
                <van-field
                v-model="code"
                center
                clearable
                :label="$t('yzm')"
                :placeholder="$t('qtxyzm')"
                >
                <template #button>
                    <van-button size="small" @click="sentout" :disabled ="disabled" type="info">{{times}}</van-button>
                </template>
                </van-field>
            </div>

           <div class="">
               <van-field
                    label-width="6em"
                    v-model="email"
                    type="text"
                    :name="$t('pwas')"
                    :label="$t('zhmmyx')"
                    :placeholder="$t('zhmmyx')"
                    :rules="[{ required: true, message: 'sss' }]"
                    
                />
           </div>

            <div class="">
                <van-field
                v-model="code"
                center
                clearable
                :label="$t('yxyzm')"
                :placeholder="$t('yxyzm')"
                >
                <template #button>
                    <van-button size="small" @click="sentout" :disabled ="disabled" type="info">{{this.$t('hqyxyzm')}}</van-button>
                </template>
                </van-field>
            </div>

            

            <div style="margin: 16px;">
                <van-button round block type="info" @click="onSubmit" native-type="submit">{{$t('zc')}}</van-button>
            </div>
        </van-form>

        <router-link to='/login'>
            <p>{{$t('yyzhqqdl')}}</p>
        </router-link>
        
    </div>
</template>
<script>
import { Toast } from 'vant';

export default {
  data() {
    return {
        value:'',
        address:'+86',
        username: '',
        password: '',
        times:this.$t('hqyzm'),
        disabled:false,
        code:'',
        email:''
    };
  },

  watch: {
    $route: {
        handler: function(val){
            console.log(val);
        },
        // 深度观察监听
        deep: true
    }
  },
  
  methods: {
    //   注册
    onSubmit() {
     let data={
        method:'acs.user.register',
        mobile:this.username,
        password:this.password,
        appid:'7',
        platform:'pwa',
        code:this.code
     }
     this.$serve(data).then(res=>{
         if(res.data.code==0){
             Toast.success(this.$('zccg'));
             this.$router.push({ path: '/login' })
         }else{
             Toast.fail(this.$t('zcsb'));
         }
     })
    },
    
    selectHand(){
        this.$router.push({path:'/indexbar'})
    },
    sentout(){
        let data ={
            method:'acs.code.build',
            name:this.username,
            type:'0',
            platform:'web',
            appid:'7'
        }
        this.$serve(data).then(res=>{
            console.log(res)
            if(res.data.code==0){
                Toast.success(this.$t('fscg'));
            }else if(res.data.code==-14){
                Toast.fail(this.$t('yhycz'));
            }else{
                Toast.fail(this.$t('fssb'));
            }
        })
        this.disabled = true
        var second = 10
        var clearTimeSet=setInterval( () =>{
            this.times = second+'s'
            second=second-1
          if(second==0){
              clearInterval(clearTimeSet);
              this.disabled = false
              this.times = this.$t('hqyzm')
          }
        }, 1000);
    }
  },
};
</script>
<style scoped>
.content{
    padding-top: 100px;
    
}
.phone{
    padding: 0 0 0 20px;
    margin: 0 auto;

    /* line-height: 35px; */
    display: flex;
    justify-content: flex-start;
}
.phone select{
    border: none;
    margin: 0;
    padding: 0;
    margin-right: 4px;
    flex: 1;
    background-color: #ffff;
}
.phone input{
    border: none;
    flex: 5;
}

.resgist{
    border-bottom: 1px solid #999;
}
</style>